import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: 'root'
})
export class ServicioGestionCargueService {

  constructor(private http: HttpClient, private utils: Utils) {}

   public PaquetesConsultar(idServicioEncabezado): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_GESTIONENTREGAS + '/paquetes/' + idServicioEncabezado;
    return this.returnMetodo(url, "ENTREGAS", "Error al consultar paquetes", "error", TipoSincronizacion.Get, null);
  }

  public MotivosConsultar(idTpoMotivo): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_GESTIONENTREGAS + '/motivos/' + idTpoMotivo;
    return this.returnMetodo(url, "ENTREGAS", "Error al consultar paquetes", "error", TipoSincronizacion.Get, null);
  }

  public EntregaGuardar(NvoEntrega): Observable <any> {
    const url = Constants.BASE_URL + Constants.URL_GESTIONENTREGAS + '/entregaCrear/';
    return this.returnMetodo(
      url,
      "GESTION ENTREGA",
      "Error al crear la nueva gestion de entrega",
      "error",
      TipoSincronizacion.Create,
      NvoEntrega
    );
  }
  public EntregasProcesar(idAgencia,idServicioEnc){
    const url = 
      "http://18.210.107.20/cncaldas_bifrost_qa/api/DataBaseSync/RunAllOnRoute/all/amb/300/"+ idAgencia +"/" + idServicioEnc ;
    return this.returnMetodo(
      url,
      "GESTION ENTREGA",
      "Error al enviar la informacion de la entrega EORDER",
      "error",
      TipoSincronizacion.Get,
      null
    );
  }

  public EntregaNueva(NvoEntrega): Observable <any> {
    const url = Constants.BASE_URL + Constants.URL_GESTIONENTREGAS + '/entregaGuardar/';
    return this.returnMetodo(
      url,
      "GESTION ENTREGA",
      "Error al crear la nueva entrega",
      "error",
      TipoSincronizacion.Create,
      NvoEntrega
    );
  }
  public EntregaVerificar(NvoEntrega): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_GESTIONENTREGAS+ '/entregaVerificarExiste/';
    return this.returnMetodo(url, "ENTREGAS", "Error al verificar paquete", "error", TipoSincronizacion.Get, NvoEntrega);
  }

   public returnMetodo(url, tituloErr, msgErr, icnErr, tipoSincron: TipoSincronizacion, bodyData: any): Observable <any> {
    const fnErr =
      catchError((err) => {
        console.log(err);
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
           Swal.fire({
             title: tituloErr,
             text: msgErr,
             type: "error",
           });
        }
        return throwError(err);
      })
    ;
    switch(tipoSincron){
      case TipoSincronizacion.Create:
         return this.http.post<any>(url, bodyData).pipe(
           fnErr
          );
        break;
        case TipoSincronizacion.Delete:
          return this.http.delete<any>(url).pipe(
            fnErr
           );
        break;
        case TipoSincronizacion.Get:
          return this.http.get<any>(url).pipe(
            fnErr
           );
        break;
        case TipoSincronizacion.Update:
          return this.http.put<any>(url, bodyData).pipe(
            fnErr
           );

        break;
    }

  }

}

enum  TipoSincronizacion  {
  Get= 0,
  Delete= 1,
  Update= 2,
  Create= 3,
}
